import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import Item from './Item'

const ListItem = ({ itemId, itemById, deleteItem }) => {
  const [itemDisplay, setItemDisplay] = useState({})

  useEffect(() => {
    const newItemDisplay = {}
    itemId.forEach((id) => {
      const item = itemById[id]
      if (item) {
        if (!newItemDisplay[item.level]) {
          newItemDisplay[item.level] = [item]
        } else {
          newItemDisplay[item.level].push(item)
        }
      }
    })
    setItemDisplay(newItemDisplay)
  }, [itemId, itemById])

  const levels = Object.keys(itemDisplay)

  return (
    <>
      {levels.map((level) => {
        const items = itemDisplay[level]
        return items.map((item, index) => {
          return (
            <Item
              key={item.id}
              isDisplayLevel={index === 0}
              item={item}
              deleteItem={deleteItem}
            />
          )
        })
      })}
    </>
  )
}

ListItem.propTypes = {
  itemId: PropTypes.array.isRequired,
  itemById: PropTypes.object.isRequired,
  deleteItem: PropTypes.func.isRequired,
}

export default ListItem
